import React from "react";
import swal from 'sweetalert2';

const Alerts = () => { }

export default Alerts;

Alerts.ShowAlert = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
    });
}

Alerts.ShowAlertFullScreen = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
        grow: "fullscreen"
    });
}

Alerts.ShowAlertFullScreenCryptoCopy = (ptitle, pmessage, picon, descriptor, amount) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
        grow: "fullscreen",
        didOpen: () => {
            const descriptorSpan = document.getElementById('copyable-descriptor');
            const descriptorIcon = document.getElementById('copy-icon');

            if (descriptorSpan && descriptorIcon) {
                descriptorIcon.addEventListener('click', () => {
                    navigator.clipboard.writeText(descriptor);
                    descriptorSpan.style.color = 'lightgreen';
                    setTimeout(() => {
                        descriptorSpan.style.color = '';
                    }, 2000);
                });
            }

            const amountSpan = document.getElementById('copyable-amount');
            const amountIcon = document.getElementById('copy-amount-icon');

            if (amountSpan && amountIcon) {
                amountIcon.addEventListener('click', () => {
                    navigator.clipboard.writeText(amount);
                    amountSpan.style.color = 'lightgreen';
                    setTimeout(() => {
                        amountSpan.style.color = '';
                    }, 2000);
                });
            }
        }
    });
};


Alerts.ShowP2PAlert = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
        width: 800,
    });
}


Alerts.SessionAlert = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        buttons: false,
        closeOnEsc: false,
        closeOnClickOutside: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: false,
        allowOutsideClick: false
       
    });
}

Alerts.ShowMessageLoader = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
            swal.showLoading();
        }
    });
}

Alerts.VerificationID = (verificationUrl, onComplete) => {
    if (!verificationUrl || verificationUrl === 'undefined' || verificationUrl === 'null') {
        Alerts.ShowAlert("Error", "Invalid verification URL", "error");
        return;
    }

    swal.fire({
        title: 'Document ID Verification',
        html: `
            <div style="width: 100%; height: 550px; position: relative;">
                <div id="iframe-loading" style="
                        position:absolute;
                        top:0;
                        left:0;
                        width:100%;
                        height:100%;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        background:#fff;
                        z-index:10;
                        font-size:16px;
                        font-weight:600;
                      ">
                    Please wait, your form will load in a few seconds...
                </div>
                <iframe
                    id="verification-iframe"
                    src="${verificationUrl}" 
                    style="width: 100%; height: 100%; border: none; display: block; border-radius: 8px;"
                    frameborder="0"
                    allow="camera; microphone"
                    title="Document ID Verification"
                ></iframe>
            </div>
        `,
        width: '800px',
        padding: '30px',
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Complete the verification process and click this button when finished',
        confirmButtonColor: '#28a745',
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
            popup: 'verification-modal-popup',
            htmlContainer: 'verification-modal-container',
            confirmButton: 'verification-confirm-btn'
        },
        didOpen: () => {

            const iframe = document.getElementById('verification-iframe');
            const loader = document.getElementById('iframe-loading');

            if (!iframe) {
                return;
            }

            // ? Listener para cuando carga exitosamente
            iframe.onload = () => {
                if (loader) {
                    loader.style.display = 'none';
                }
            };

            // ? Listener para errores de carga
            iframe.onerror = (error) => {
                if (loader) {
                    loader.innerHTML = `
                        <div style="color: red;">
                            <strong>Error loading verification form.</strong><br>
                            Please try again or contact support.
                        </div>
                    `;
                }
            };

            // ? Timeout de seguridad si el iframe no carga en 10 segundos
            setTimeout(() => {
                if (loader && loader.style.display !== 'none') {
                    loader.innerHTML = `
                        <div>
                            <strong>The form is taking longer than expected...</strong><br>
                            Please wait a moment.
                        </div>
                    `;
                }
            }, 10000);
        },
        willClose: () => {
            document.body.style.overflow = 'unset';
        }
    }).then((result) => {

        if (result.isConfirmed) {
            if (onComplete && typeof onComplete === 'function') {
                onComplete();
            }
        }
    });
};

Alerts.CoinflowRegisterUser = (verificationUrl, onComplete) => {
    if (!verificationUrl || verificationUrl === 'undefined' || verificationUrl === 'null') {
        Alerts.ShowAlert("Error", "Invalid verification URL", "error");
        return;
    }

    swal.fire({
        title: 'Register User',
        html: `
            <div style="width: 100%; height: 550px; position: relative;">
                <div id="iframe-loading" style="
                        position:absolute;
                        top:0;
                        left:0;
                        width:100%;
                        height:100%;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        background:#fff;
                        z-index:10;
                        font-size:16px;
                        font-weight:600;
                      ">
                    Please wait, your form will load in a few seconds...
                </div>
                <iframe
                    id="verification-iframe"
                    src="${verificationUrl}" 
                    style="width: 100%; height: 100%; border: none; display: block; border-radius: 8px;"
                    frameborder="0"
                    allow="camera; microphone"
                    title="Document ID Verification"
                ></iframe>
            </div>
        `,
        width: '800px',
        padding: '30px',
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Complete the verification process and click this button when finished',
        confirmButtonColor: '#28a745',
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
            popup: 'verification-modal-popup',
            htmlContainer: 'verification-modal-container',
            confirmButton: 'verification-confirm-btn'
        },
        didOpen: () => {

            const iframe = document.getElementById('verification-iframe');
            const loader = document.getElementById('iframe-loading');

            if (!iframe) {
                return;
            }

            // ? Listener para cuando carga exitosamente
            iframe.onload = () => {
                if (loader) {
                    loader.style.display = 'none';
                }
            };

            // ? Listener para errores de carga
            iframe.onerror = (error) => {
                if (loader) {
                    loader.innerHTML = `
                        <div style="color: red;">
                            <strong>Error loading verification form.</strong><br>
                            Please try again or contact support.
                        </div>
                    `;
                }
            };

            // ? Timeout de seguridad si el iframe no carga en 10 segundos
            setTimeout(() => {
                if (loader && loader.style.display !== 'none') {
                    loader.innerHTML = `
                        <div>
                            <strong>The form is taking longer than expected...</strong><br>
                            Please wait a moment.
                        </div>
                    `;
                }
            }, 10000);
        },
        willClose: () => {
            document.body.style.overflow = 'unset';
        }
    }).then((result) => {

        if (result.isConfirmed) {
            if (onComplete && typeof onComplete === 'function') {
                onComplete();
            }
        }
    });
};